import xcolors from "@cdx/common/xui/xcolors";

export default xcolors;
